import { render, staticRenderFns } from "./TableUserItem.vue?vue&type=template&id=2b018db5&scoped=true&"
import script from "./TableUserItem.vue?vue&type=script&lang=js&"
export * from "./TableUserItem.vue?vue&type=script&lang=js&"
import style0 from "./TableUserItem.vue?vue&type=style&index=0&id=2b018db5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b018db5",
  null
  
)

export default component.exports